<div class="container">
  <div class="container text-center">
    <br>
    <div class="alert alert-info">
        <p>Exmo(a). Sr(a). Dr(a).  Juiz(a), </p>
        <p>Levamos ao conhecimento desse D. Juízo que a ordem de exclusão em referência foi cumprida em seus exatos termos, sendo certo que excluímos a anotação de ação referente ao processo em referência.</p>
        <p>Sem mais para o momento, apresentamos nossos protestos de elevada estima e distinta consideração.</p>
        <p><b>SERASA S.A.</b></p>
        <p><b>Gestão de Mandados e Requerimentos</b></p>
  </div>
</div>
